import React from "react"
import styles from "../../styles/NotFound.module.css"
const NotFound = () => {
  return (
    <div className={styles.container}>
      <h1 className={styles.title}>404</h1>
      <p className={styles.message}>
        Oops! The page you're looking for doesn't exist.
      </p>
      <a href="/" className={styles.link}>
        Go back to the homepage
      </a>
    </div>
  )
}

export default NotFound
